import React from 'react';

export default function Eflyers() {
  const flyerStyle = {
    display: 'inline-block',
    width: 'auto',
    marginRight: 16,
    textAlign: 'center',
  };

  return (
    <div style={{ margin: 18 }}>
      <h1>E-Flyer: English</h1>


        <div style={flyerStyle}>
          <a
            href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+Oct+Antifreeze.pdf"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <img
              src="https://e-flyers.s3.us-west-2.amazonaws.com/thumbnails/Antifreeze+2026+EN.png"
              alt="2026 Antifreeze October Special"
              style={{
                display: 'block',
                margin: '0 auto 8px',
                width: 200,
                height: 'auto',
              }}
            />
            <div>2026 Antifreeze October Special</div>
          </a>
        </div>

        <div style={flyerStyle}>
          <a
            href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+Oct+ADCO+Covers+Specials.pdf"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <img
              src="https://e-flyers.s3.us-west-2.amazonaws.com/thumbnails/ADCO+2026+EN.png"
              alt="2026 ADCO Cover October Specials"
              style={{
                display: 'block',
                margin: '0 auto 8px',
                width: 200,
                height: 'auto',
              }}
            />
            <div>2026 ADCO Cover October Specials</div>
          </a>
        </div>
      

      <div style={{ marginTop: 32 }}>
        <h1>E-Flyer: French</h1>


          <div style={flyerStyle}>
            <a
              href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+Oct+Antifreeze+FRENCH.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <img
                src="https://e-flyers.s3.us-west-2.amazonaws.com/thumbnails/Antifreeze+2026+FR.png"
                alt="Spécial antigel de octobre 2026"
                style={{
                  display: 'block',
                  margin: '0 auto 8px',
                  width: 200,
                  height: 'auto',
                }}
              />
              <div>Spécial antigel de octobre 2026</div>
            </a>
          </div>

          <div style={flyerStyle}>
            <a
              href="https://e-flyers.s3.us-west-2.amazonaws.com/2026+Oct+ADCO+Covers+Specials+FRENCH.pdf"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <img
                src="https://e-flyers.s3.us-west-2.amazonaws.com/thumbnails/ADCO+2026+FR.png"
                alt="Spéciaux ADCO de octobre 2026"
                style={{
                  display: 'block',
                  margin: '0 auto 8px',
                  width: 200,
                  height: 'auto',
                }}
              />
              <div>Spéciaux ADCO de octobre 2026</div>
            </a>
          </div>
        </div>
      </div>
    
    
  );
}
